import React, { useEffect, useState, useCallback } from 'react';
import { Tabs, Row, Col, Pagination, Empty } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomNavbar from '../components/Navbar';
import ShortlistCard from '../components/ShortlistCard';
import api from '../api/axios';
import { useProfile } from '../context/ProfileContext';


import Swal from 'sweetalert2';

const Shortlist = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [activeKey, setActiveKey] = useState('1');
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [profiles, setProfiles] = useState([]);
    const [totalProfiles, setTotalProfiles] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const { profileId } = useProfile();

    useEffect(() => {
        if (location.pathname === '/shortlists/by-me') {
            setActiveKey('1');
        } else if (location.pathname === '/shortlists/by-others') {
            setActiveKey('2');
        }
    }, [location.pathname]);

    const fetchProfiles = useCallback(async (key, page, limit) => {
        const typeMap = {
            '1': 'by-me',
            '2': 'by-others',
        };
        const type = typeMap[key];
        try {
            const response = await api.post(
                `/shortlists/${type}?page=${page}&limit=${limit}`,
                { profile_id: profileId }
            );
            setProfiles(response.data.data.data);
            setTotalProfiles(response.data.data.total);
            setPerPage(response.data.data.per_page);
        } catch (error) {
            console.error('Error fetching profiles:', error);
        }
    }, [profileId]);

    useEffect(() => {
        fetchProfiles(activeKey, currentPage, pageSize);
    }, [activeKey, currentPage, pageSize, fetchProfiles]);

    const handleTabChange = (key) => {
        if (key === '1') {
            navigate('/shortlists/by-me');
        } else if (key === '2') {
            navigate('/shortlists/by-others');
        }
    };

    const handlePageChange = (page, pageSize) => {
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleRemoveShortlist = async (shortlistId, shortlistedId) => {
        try {
            const response = await api.delete(
                `/shortlists/delete/${shortlistId}`,
                {
                    data: { shortlister_id: profileId, shortlisted_id: shortlistedId },
                }
            );

            if (response.data?.status === 'success') {
                Swal.fire({
                    title: 'Shortlist Removed!',
                    text: 'The shortlist has been removed.',
                    icon: 'success'
                }).then(() => {
                    fetchProfiles(activeKey, currentPage, pageSize);
                });
            } else {
                Swal.fire({
                    title: 'Error',
                    text: 'There was an error removing the shortlist.',
                    icon: 'error'
                });
            }
        } catch (error) {
            console.error('Error removing shortlist:', error);
            Swal.fire({
                title: 'Error',
                text: 'There was an error removing the shortlist.',
                icon: 'error'
            });
        } finally {
            fetchProfiles(activeKey, currentPage, pageSize);
        }
    };

    const renderProfiles = (profiles) => {
        if (profiles.length === 0) {
            return (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <Empty description="No Data" />
                </div>
            );
        }

        return (
            <Row gutter={[16, 16]} className="mt-4">
                {profiles.map((profile) => (
                    <Col key={profile.id} xs={24} sm={12} md={8} lg={6}>
                        <ShortlistCard
                            profile={profile}
                            onRemove={handleRemoveShortlist}
                            activeKey={activeKey}
                        />
                    </Col>
                ))}
            </Row>
        );
    };

    const tabItems = [
        {
            key: '1',
            label: <span style={{ fontFamily: 'Calibri, sans-serif', fontSize: '1.0rem', fontWeight: 'normal' }}>Shortlisted by me</span>,
            children: (
                <>
                    {renderProfiles(profiles)}
                    {totalProfiles > perPage && (
                        <Pagination
                            current={currentPage}
                            pageSize={pageSize}
                            total={totalProfiles}
                            onChange={handlePageChange}
                            style={{ textAlign: 'center', marginTop: '16px' }}
                        />
                    )}
                </>
            ),
        },
        {
            key: '2',
            label: <span style={{ fontFamily: 'Calibri, sans-serif', fontSize: '1.0rem', fontWeight: 'normal' }}>Others who shortlisted me</span>,
            children: (
                <>
                    {renderProfiles(profiles)}
                    {totalProfiles > perPage && (
                        <Pagination
                            current={currentPage}
                            pageSize={pageSize}
                            total={totalProfiles}
                            onChange={handlePageChange}
                            style={{ textAlign: 'center', marginTop: '16px' }}
                        />
                    )}
                </>
            ),
        },
    ];

    useEffect(() => {
        const titles = {
            '/shortlists/by-me': 'Shortlisted by Me',
            '/shortlists/by-others': 'Shortlisted by Others',
        };
        document.title = `${titles[location.pathname] ?? 'Shortlist'} | Oottan`;
    }, [location.pathname]);

    return (
        <div style={{ fontFamily: 'Calibri, sans-serif' }}>
            <CustomNavbar onNavbarReady={() => {}} />
            <div className="container py-5">
                <div style={{ marginTop: '15px' }}>
                    <Tabs activeKey={activeKey} onChange={handleTabChange} centered items={tabItems} />
                </div>
            </div>
        </div>
    );
}

export default Shortlist;